module.exports = __webpack_public_path__ + "img/share-all.39269d2b.svg";